import React from 'react';
import PageContainer from '../pagecontainer/PageContainer';
import { useClaimsShopSettings } from './ClaimsShopSettingsContext';

export const menuItems = [
  {
    id: '/parcel-finder',
    link: '/parcel-finder',
    title: 'Parcel finder',
  },
  {
    id: '/parcel-finder/claims-center',
    link: '/parcel-finder/claims-center',
    matchPaths: ['/parcel-finder/claims-center/*'],
    title: 'Claims center',
    shopAccess: 'isClaimsEnabled',
  },
  {
    id: '/parcel-finder/carrier-claim-payments',
    link: '/parcel-finder/carrier-claim-payments',
    title: 'Carrier claim payments',
    shopAccess: 'isClaimsEnabled',
  },
  {
    id: '/analytics/claims/claims-overview',
    link: '/analytics/claims/claims-overview',
    title: 'Claims overview',
    shopAccess: 'isClaimsEnabled',
  },
  {
    id: '/parcel-finder/start-guide',
    link: '/parcel-finder/start-guide',
    title: 'Start guide',
  },
];

/**
 * @param {ClaimsShopSettings} [settings]
 */
function getMenuItems(settings) {
  return settings?.isClaimMeCustomer
    ? menuItems
    : menuItems.filter((item) => item.id !== '/parcel-finder/carrier-claim-payments');
}

function ParcelFinderContainer(props) {
  const settings = useClaimsShopSettings();
  const menuTitle = settings?.isClaimMeCustomer ? 'claim.me' : 'Parcel Finder + Claims';

  return (
    <PageContainer {...props} menuTitle={menuTitle} menuItems={getMenuItems(settings)}>
      {props.children}
    </PageContainer>
  );
}

export default ParcelFinderContainer;
